import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { createSelector, select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectAppConfig } from 'src/app/core/application-config/application-config.selectors';
import { LocaleService } from 'src/app/core/locale/locale.service';
import { routeTo } from 'src/app/core/routing/routing.actions';
import { APPCONFIG_ACCESSO_ID, APPCONFIG_MERCHANT_LOCALE_SUFFIX } from 'src/app/shared/enums/application-config.enums';

@Component({
	selector: 'ahp-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
	/**
	 * App config value to append merchant suffix to locales
	 */
	public merchantLocaleSuffix: string;
	/**
	 * App config value to enable accesso id
	 */
	private _accessoIdEnabled: boolean;
	/**
	 * unsubscribes from observables
	 */
	private _destroy$ = new Subject<void>();
	/**
	 * @param _store$ the store
	 * @param _locale the locale service
	 * @param _title the title service
	 */
	constructor(private _store$: Store, private _locale: LocaleService, private _title: Title) {
		this._title.setTitle(this._locale.get('dashboard.page_title'));

		this._store$
			.pipe(
				select(
					createSelector(
						selectAppConfig([APPCONFIG_MERCHANT_LOCALE_SUFFIX, APPCONFIG_ACCESSO_ID]),
						(configs) => {
							return {
								configs,
							};
						}
					)
				),
				takeUntil(this._destroy$)
			)
			.subscribe(({ configs }) => {
				this._accessoIdEnabled = configs?.accesso_id?.enable;
				this.merchantLocaleSuffix = configs?.merchant_locale_suffix;
			});
	}

	public ngOnInit(): void {
		if (!this._accessoIdEnabled) {
			this._store$.dispatch(routeTo({ payload: ['account', 'overview'] }));
		}
	}
}
